module.exports = __webpack_public_path__ + "img/foto.f9ad0257.svg";